import { addYears, format } from 'date-fns'
import { Offer, Place, WithContext } from 'schema-dts'
import { AmsItem, UsageState } from '../../services/amsSearch/amsSearch.interface'
import { ScreenSize } from '@sunrise/types'

export const amsItemJsonLd = (item: AmsItem): WithContext<Offer> => ({
    '@context': 'https://schema.org',
    '@id': `#${item.position}`,
    '@type': 'Offer',
    availability: 'InStock',
    url: item.url,
    priceCurrency: 'EUR',
    price: item.price,
    priceValidUntil: createDateOneYearFromNow(),
    itemOffered: [
        {
            '@type': 'Vehicle',
            additionalType: 'Product',
            name: item.title,
            description: item.title,
            ...createImage(item),
            itemCondition: item.usageState === UsageState.New ? 'NewCondition' : 'UsedCondition',
            dateVehicleFirstRegistered: createFirstRegistrationDate(
                item.initialRegistrationDate,
                item.initialRegistrationDateMonth,
            ),
            sku: 'n/a',
            mpn: 'n/a',
            brand: [
                {
                    '@type': 'Brand',
                    name: item.make,
                },
            ],

            mileageFromOdometer: [
                {
                    '@type': 'QuantitativeValue',
                    unitCode: 'KTM',
                    value: item.mileage,
                },
            ],
            offers: [{ '@type': 'Offer', '@id': `#${item.position}` }],
        },
    ],
    ...createLocation(item),
})

const createImage = (item: AmsItem) =>
    item.resizedImages.length
        ? {
              image: item.resizedImages[0][ScreenSize.XXL] as string,
          }
        : {}

const createLocation = (item: AmsItem): Partial<{ availableAtOrFrom: Place[] }> =>
    item.onlinePurchase && !item.city
        ? {}
        : {
              availableAtOrFrom: [
                  {
                      '@type': 'Place',
                      name: item.city,
                  },
              ],
          }

const createDateOneYearFromNow = (): string => {
    const date = addYears(new Date(), 1)

    return format(date, 'yyyy-MM-dd')
}

const createFirstRegistrationDate = (year: number, month?: number) => {
    if (month) {
        return `${year} - ${month}`
    } else {
        return `${year}`
    }
}
